package com.example.readingnotes.presentation.stripeconnect

/**
 * UI events for Stripe Connect onboarding screen
 */
sealed interface StripeConnectEvent {
    /**
     * Screen appeared - load initial status
     */
    data object OnAppear : StripeConnectEvent

    /**
     * User clicked start onboarding button
     */
    data object OnStartOnboarding : StripeConnectEvent

    /**
     * User clicked refresh button
     */
    data object OnRefresh : StripeConnectEvent

    /**
     * OAuth callback received with authorization code
     */
    data class OnCallback(
        val code: String,
    ) : StripeConnectEvent

    /**
     * Clear error message
     */
    data object OnClearError : StripeConnectEvent

    /**
     * Open Stripe dashboard
     */
    data object OnOpenDashboard : StripeConnectEvent
}
